import euTheme from './eu-theme'
import defaultTheme from './default-theme'
import bemaTheme from './bema-theme'

export const themes = {
  default: defaultTheme,
  eu: euTheme,
  bema: bemaTheme
}
